import { Common } from '~/models/common';
import { Image } from '~/models/image';
import { File } from '~/models/file';

export namespace Documents {
	export const collection = 'documents';
	export const api = `/api/${collection}`;

	export type Model = Common.Model & {
		name: string;
		preview: Image.Model | null;
		file: File.Model;
		show: boolean;
		download: boolean;
	};

	export const modelState: Model = {
		...Common.modelState,
		name: '',
		preview: null,
		file: File.modelState,
		show: true,
		download: true,
	};
}
